module.exports = __webpack_public_path__ + "img/CM-MR-26-Ford-Established.ce337970.jpg";